import Decimal from 'decimal.js';

export const IRR_CAP_PERIOD = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual',
};

export const IRR_CAP_PERIOD_OPTIONS = [
  { label: 'Monthly', value: IRR_CAP_PERIOD.MONTHLY },
  { label: 'Annual', value: IRR_CAP_PERIOD.ANNUAL },
];

const isEmpty = (value) => value === null || value === undefined || value === '';

// Intermediate NumberInput values that must not be converted yet (e.g. "1.").
export const isIncompleteRateInput = (value) =>
  typeof value === 'string' &&
  (value === '-' || value.endsWith('.') || value.endsWith('.0'));

// Yearly = (1 + Monthly) ^ 12 - 1
export const monthlyToAnnualRate = (monthlyRate) => {
  if (isEmpty(monthlyRate) || isNaN(monthlyRate)) {
    return null;
  }
  return new Decimal(1).plus(monthlyRate).pow(12).minus(1).toNumber();
};

// Monthly = (1 + Yearly) ^ (1/12) - 1
export const annualToMonthlyRate = (annualRate) => {
  if (isEmpty(annualRate) || isNaN(annualRate)) {
    return null;
  }
  return new Decimal(1).plus(annualRate).pow(new Decimal(1).div(12)).minus(1).toNumber();
};

// Convert the stored rate when the user switches monthly <-> annual.
// Typing a rate does not convert; the typed decimal is persisted with the period.
export const convertRateForPeriodChange = (rate, fromPeriod, toPeriod) => {
  if (!toPeriod || toPeriod === fromPeriod) {
    return rate;
  }
  return toPeriod === IRR_CAP_PERIOD.MONTHLY
    ? annualToMonthlyRate(rate)
    : monthlyToAnnualRate(rate);
};

// Whether the annual rate, expressed as a percentage (rate * 100), carries more
// fractional digits than the given display precision (e.g. a converted monthly rate).
export const hasExtraFractionalDigits = (annualRate, maxDecimals = 3) => {
  if (isEmpty(annualRate) || isNaN(annualRate)) {
    return false;
  }
  return new Decimal(annualRate).times(100).dp() > maxDecimals;
};
